import React, {useState, useEffect, useMemo} from "react";

//PropTypes
import PropTypes from "prop-types";

//components
import DataCard from "../../../components/Cards/DataCard";

//data
import getTableData from "./_pending-requests";


import useQueryAuth from "../../../hooks/useQueryAuth";

import useAuth from "../../../hooks/useAuth";

import { GET_ALL_REQUESTS } from "../../../graphql/requests";
import { useTranslation } from "react-i18next";

const PendingRequests = ({ tenant = null }) => {

  const [loading, setLoading] = useState(false); //set true when we wish to start lazy loading

  const { t } = useTranslation();



  const { userRoles, storeUserTenant } = useAuth();

  const {isEntelligence} = userRoles;

   /**States for All Requests */
   const [_allRequests, _setAllRequests] = useState([]);
   const [_allRequestsNumb, _setAllRequestsNumb] = useState(0);

   const {
    loading: allRequestLoading,
  } = useQueryAuth(
    GET_ALL_REQUESTS,
    "GetAllRequests",
    {
      variables: {
        model: {
          enableFilters: false,
          isPending: true,
          tenantID: isEntelligence
            ? tenant != null
              ? tenant.tenantGuid
              : undefined
            : storeUserTenant,
        },
      }
    },
    {
      onCompleted: (response) => {
        var array = response?.GetAllRequests?.requestsListModel?.requests || [];

        _setAllRequests((records) => [...records, ...array]);
        _setAllRequestsNumb(
          response?.GetAllRequests?.requestsListModel?.totalNumberOfRecords || 0
        );
      },
    }
  );



  const _records = useMemo(()=>_allRequests || [], [_allRequests]); //holds data
  const _maxRecords = _allRequestsNumb || 0; //holds total number of records in database that satisfy the query

  useEffect(() => {
    if (_records && _records.length > 0) setLoading(false);
  }, [_records]);

  function fetchData() {
    //function that gets records on lazy load

    if (allRequestLoading) return; //data is already being fetched, we wait for it to at least be fetched

    if (_records.length >= _maxRecords) return; //if data has reached its max

  }

  const _tableData = getTableData(t);

  const { title, headers, render } = _tableData; //holds card title, table headers and the display of data

  const stopLazyLoad = _records.length >= _maxRecords; //if all records have been fetched we no longer wish to lazy load

 
  return (
    <DataCard
      id="dashboard-requests-modal"
      title={title}
      stopLazyLoad={stopLazyLoad}
      onLazyLoad={fetchData}
      tableHeaders={headers}
      render={render}
      data={_records}
      initialLoad={!(allRequestLoading&&_allRequestsNumb === 0)}
      loading={loading}
      setLoading={setLoading}
    />
  );
};

PendingRequests.propTypes = {
  initialLoad: PropTypes.bool,
  data: PropTypes.object,
  next: PropTypes.func,
  waitBatch:PropTypes.bool
};

PendingRequests.defaultProps = {
  initialLoad: false,
  data: {},
  next: ()=>{},
  waitBatch:false
};

export default PendingRequests;
